import axios from 'axios';
import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { Button, Card, CardBody, CardHeader } from 'reactstrap';
// import CarSvg from '../../carbodyparts/CarSvg';
import CarSvgAUT from '../../carbodyparts/CarSvgAUT';
import AUTPriceTable from '../common/AUTPriceTable';
import CustomerInfoTable from '../common/CustomerInfoTable';
import ReportFooter from '../common/ReportFooter';
import ReportHeader from '../common/ReportHeader';
import ReportHeader_Swiss from '../common/ReportHeader_Swiss';
import ReportFooter_Swiss from '../common/ReportFooter_Swiss';
import Spinner from "../../../src/spinner/index";
import AllReportScanImages from '../common/AllReportScanImages';
import ScrollToTop from '../common/ScrollToTop';
import SwissFullReportAuthorization from '../common/SwissFullReportAuthorization';

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

export class ReportFullAUT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            words: {},
            lang: "",
            imageLoading: true,
        }
        this.setImageLoading = this.setImageLoading.bind(this);
    }

    componentDidMount = () => {
        this.getLang()
    }

    setImageLoading(loading) {
        this.setState({ imageLoading: loading });
    }

    getLang = () => {
        const base_url = window.location.origin;
        axios.get(`${base_url}/lang.json`).then((res) => {
            let lang = localStorage.getItem("lang");
            this.setState({ lang: lang });
            this.setState({ words: res.data });
        });
    };

    lang = (word) => {
        const { lang, words } = this.state;
        return words[word] ? words[word][lang] : word;
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.lang !== prevState.lang) {
            return { lang: nextProps.lang };
        } else return null;
    }

    render() {
        const { imageLoading } = this.state;
        return (
            <div className="animated fadeIn">
                <div xs="12" sm="12" className="p-2">

                    <Card className="print_button_card">
                        <CardHeader>
                            <div className="container-fluid">
                                <div className="row align-items-center p-0">
                                    <div className="col-lg-3 col-md-6 col-sm-6 col-12 mt-sm-10">
                                        <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small>
                                    </div>
                                    <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                                        <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                                            <SwissFullReportAuthorization />
                                            <ReactToPrint
                                                trigger={() => {
                                                    document.title = document.title =
                                                        localStorage.getItem("selectedFile");
                                                    return (
                                                        <button className="btn btn-danger btn-lg pull-right">
                                                            <i className="fa fa-print" /> {this.lang("Print PDF")}
                                                        </button>
                                                    );
                                                }}
                                                content={() => this.componentRef}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                    {/* <Card>
                <CardHeader>
                    <ReactToPrint trigger={() => {
                        document.title = localStorage.getItem("selectedFile");
                        return (
                            <button className="glass btn btn-lg btn-danger pull-right">
                                <i className="fa fa-print" />
                                &nbsp; Print PDF
                            </button>
                        );
                    }}
                        content={() => this.componentRef}
                    />
                    <Button className="btn-danger mr-2" onClick={()=>this.backtoDashboard()}>{this.lang("Back")}</Button>
                    <small> {this.lang("VIN Number")} : {localStorage.getItem("selectedFile")}</small>
                </CardHeader>
            </Card> */}
                    <div className="container all-reports-top-wrapper"
                        // id="divIdToPrint"
                        ref={(el) => (this.componentRef = el)}
                        style={{ padding: 0 }}
                    >
                        {!imageLoading ? (
                            <>
                                <div className="row row-zero page-break-row report-full-wrapper" data-content-name={this.lang("Page")}>
                                    <div className="col-sm-12 full-height-col col-zero">
                                        <Card>
                                            <CardBody className="col-zero">
                                                <div className="newFormatReport_wrapper">
                                                    {/* <ReportHeader /> */}
                                                    <ReportHeader_Swiss />
                                                    <div className="p-0 row ">
                                                        <CustomerInfoTable />
                                                        <AUTPriceTable />
                                                    </div>
                                                </div>
                                            </CardBody>
                                            <ReportFooter_Swiss />
                                        </Card>
                                    </div>
                                </div>
                                <div className="row row-zero page-break-row report-full-wrapper second-svg-section" data-content-name={this.lang("Page")}>
                                    <div className="col-sm-12 full-height-col col-zero">
                                        <Card>
                                            <CardBody className="col-zero">
                                                <div className="newFormatReport_wrapper">
                                                    <ReportHeader_Swiss />
                                                    <div className="container car-svg-main">
                                                        <div className="row title-row-main">
                                                            <div className="col-sm-12 col-zero">
                                                                <h3 className='report-title'>
                                                                    {this.lang("2D")}<span> {this.lang("View")} </span>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-12 m-0 p-0">
                                                                {/* <CarSvg {...this.props} /> */}
                                                                <CarSvgAUT {...this.props} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                            <ReportFooter_Swiss />
                                        </Card>
                                    </div>
                                </div>

                            </>
                        ) : (
                            <>
                                <Spinner />
                            </>
                        )}
                        <AllReportScanImages imageLoading={this.state.imageLoading} setImageLoading={this.setImageLoading} />
                    </div>

                    {/* <div>
                <Card>
                    <CardBody>
                        <Link className="glass" to="/ReportFull">
                            <button className="btn btn-danger btn-sm pull-right">
                                <i className="fa fa-dot-circle-o"></i> {">>"}
                            </button>
                        </Link>
                        <Link className="glass" to="/TabView">
                            <button
                                style={{ marginRight: 10 }}
                                className="btn btn-danger btn-sm pull-right"
                            >
                                {"<<"} <i className="fa fa-dot-circle-o"></i>
                            </button>
                        </Link>
                    </CardBody>
                </Card>
            </div> */}
                </div>
                <ScrollToTop />
            </div>
        )
    }
}

export default ReportFullAUT